import React from 'react';
import classes from './ProductListItem.module.css';

const ProductListItem = (props) => {
    console.log(props.product);
    console.log("Price : " + props.hidePrice);
    let price;
    if(props.product.hasOwnProperty('take') && props.takeAway){
        price = props.product.take;
    }else{
        price = props.product.price;
    }
    

    let styles = ["ProductListItemPrice"];
    if(props.takeAway) styles.push("takeAway");


    let bg = null
    if (props.product.hasOwnProperty('bg')){
        bg = { backgroundColor : "#F5B700", color : "#000"};
    }

    return (
        <div className={classes.ProductListItem} data-filter={props.product.filter} style={bg}>
            {props.product.hasOwnProperty('img') 
                ?   <div className={classes.ProductListItemImage}>
                        <img src={`../${props.product.img}`} alt={props.product.name[0]}/>
                    </div>
                : null }
            <div className={classes.ProductListItemName}>
                {props.product.name[0]}
                {props.product.hasOwnProperty('sponsor') 
                ? <img src={props.product.sponsor} alt="sponsor logo"/>
                : null }
                {props.product.hasOwnProperty('name2') ? <b> {props.product.name2[0]} </b> : null }
                {props.product.hasOwnProperty('description') 
                ? <div className={classes.ProductListItemDescription}>{props.product.description[0]}</div>
                : null }
                
            </div>
            {   (props.hidePrice === false)
                ?
                    <div className={(props.takeAway ?[classes.ProductListItemPrice, classes.TakeAway].join(' ') : classes.ProductListItemPrice)}>
                        <div className="price">{price.toFixed(2)}</div>
                        
                        {props.product.hasOwnProperty('extraPrice') 
                        ?   <div className={classes.ProductListItemBottle}>
                                {props.product.extraPrice.price.toFixed(2)}
                                <span >{props.product.extraPrice.info}</span>
                            </div>
                        : null}
                    </div>
                : null
            }
            
            
            
        </div>
    )
}

export default ProductListItem;
